var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('Sider',{attrs:{"hide-trigger":""}},[_c('my-menu')],1),_c('Layout',[_c('Content',[(_vm.isReloadData)?_c('keep-alive',[_c('router-view')],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }